module.exports = __webpack_public_path__ + "img/HNW.png";